<template>
    <div class="expedientes">
        <MenuOpcion :titulo="titulo">            
            <!-- <template v-slot:content>
                <b-nav-form>
                    <div class="col-sm-5">
                        <b-form-select v-model="cbAno" :options="cbAno" size="md"></b-form-select>							
                    </div>
                    <div class="col-sm-7">
                        <b-form-input size="sm" class="mr-sm-2" placeholder="Busqueda ..."></b-form-input>
                        <b-button size="sm" class="my-2 my-sm-0" type="submit">BUSCAR</b-button>
                    </div>
                    
					
                </b-nav-form>                    
                <div class="float-right">
                    <b-btn 
                        variant="success"
                        v-b-tooltip.hover title="Actualizar"                         
                        @click="actualizarLista"
                    >@
                    </b-btn>                                        
                </div>
            </template> -->

            <!-- <template v-slot:content>        
                <div class="float-right">
                    <b-btn v-if="!reserva"
                        variant="outline-secondary"
                        v-b-tooltip.hover title="Actualizar Listado"                         
                        @click="actualizarLista"
                    >RESERVAS
                    </b-btn>                                                                           
                </div>
            </template> -->
        </MenuOpcion>
        
        <listaExped ref="listaE" class="mt-2"/>
        <!-- <listaExped ref="listaE" class="mt-2" v-if="!expediente"/> -->
        <!-- <exped ref="exped" class="mt-2" v-else/> -->

    </div>
</template>

<script>

import MenuOpcion from '@/components/MenuOpcion.vue'
import listaExped from '@/components/listaExped.vue'


export default {
    name: 'expedientes',
    components: {
        MenuOpcion, listaExped,
    },
    
    data() {
        return {
            titulo: 'EXPEDIENTES',

        }
    },

    created() {
        if (!this.$store.state.auth.logueado) this.$router.push('/');
    },

    computed: {
    },

    methods: {
        actualizarLista() {        
            //this.$refs.listaE.leemosReservas();
            ////this.$store.ListaReservas.leemosReservas();

            this.cbAno=this.$refs.listaE.cbAno;
        },  

        listado() {
            this.$store.state.exped={id:0};
            this.actualizarLista();
        }
    },    

}
</script>